<template>
  <div class="addShare">
    <div class="title">
      分享管理 <span>添加分享</span>
    </div>
    <div class="main">
      <div class="addShareInfo">添加分享</div>
      <div class="shareContent">

        <div class="sharelist">
          <label for="Title"><span>*</span>标题</label>
          <el-input size="small"
                    v-model="shareInfo.title"></el-input>
        </div>
        <div class="sharelist">
          <label for="remark"><span>*</span>内容</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="shareInfo.content"></el-input>
        </div>
        <div class="sharelist">
          <label for="updateImg"><span>*</span>上传图片</label>
          <div class="imgItem">
            <div class="image">
              <img v-if="shareInfo.image"
                   :src="shareInfo.image"
                   class="avatar">
            </div>
            <div class="updateImgBtn">上传图片
              <input type="file"
                     name="img"
                     id=""
                     @change="handleImgUpdate"
                     class="updateBtn"
                     accept="image/png,image/jpeg">
            </div>
            <p class="remark">图片不超过2M，格式为.jpg、.png</p>
          </div>
        </div>
        <div class="sharelist">
          <label for="URL"><span>*</span>URL</label>
          <el-input size="small"
                    name="URL"
                    v-model="shareInfo.url"></el-input>
        </div>
        <div class="sharelist">
          <label for="imgTitle"><span>*</span>所属应用</label>
          <el-select v-model="appType"
                     size="small"
                     @change="handleSelectChange">
            <el-option v-for="item in appOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="shareBtn">
          <button class="save"
                  @click="handleAddShareClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { addShare, saveUpdateShare, updateShare } from 'apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'addShare',
  data () {
    return {
      appOptions: [{
        value: 0,
        label: 'V货帮-物流端'
      },
      {
        value: 1,
        label: 'V货帮-货主端'
      },
      {
        value: 2,
        label: 'V货帮-智能硬件'
      }],
      appType: '',
      shareInfo: {
        id: '',
        title: '',
        content: '',
        image: 'http://image.jsh178.com/FlHyRHUhGsN9A07MY55PePwdABaw',
        url: ''
      }

    }
  },
  // computed: mapState({
  //   shareInfo: state => state.share.shareInfo
  // }),
  methods: {
    getData () {
      updateShare({
        id: this.shareInfo.id
      }).then(res => {
        if (res.data.code === 200) {
          this.shareInfo = res.data.data
          this.appType = res.data.data.appType
        }
      })
    },
    handleCancelClick () { // 取消
      this.$router.push({ path: '/manage/share' })
    },
    handleSelectChange () { // 获取所属应用
      this.shareInfo.appType = this.appType
    },
    handleAddShareClick () { // 添加/修改
      // console.log(this.shareInfo.appType)
      if (!this.shareInfo.title | !this.shareInfo.content | !this.shareInfo.image | !this.shareInfo.url | this.shareInfo.appType === '') {
        this.$message.error('*为必选内容')
      } else {
        // console.log(this.shareInfo.url)
        if (this.shareInfo.url.indexOf('https://') !== -1) {
          this.shareInfo.url = this.shareInfo.url.replace('https://', '')
        }
        if (this.shareInfo.url.indexOf('http://') !== -1) {
          this.shareInfo.url = this.shareInfo.url.replace('http://', '')
        }
        // console.log(this.shareInfo.url)

        if (this.shareInfo.id) {
          saveUpdateShare({ // 修改
            id: this.shareInfo.id,
            title: this.shareInfo.title,
            appType: this.shareInfo.appType,
            content: this.shareInfo.content,
            image: this.shareInfo.image,
            size: this.shareInfo.size,
            suffix: this.shareInfo.suffix,
            url: 'https://' + this.shareInfo.url
          }).then(res => {
            if (res.data.code === 200) {
              this.$router.push({ path: '/manage/share' })
            }
          })
        } else {
          // console.log('aaa', this.shareInfo.url)
          addShare({ // 添加
            title: this.shareInfo.title,
            appType: this.shareInfo.appType,
            content: this.shareInfo.content,
            image: this.shareInfo.image,
            size: this.shareInfo.size,
            suffix: this.shareInfo.suffix,
            url: 'https://' + this.shareInfo.url
          }).then(res => {
            if (res.data.code === 200) {
              this.$router.push({ path: '/manage/share' })
            }
          })
        }
      }
    },
    handleImgUpdate (e) { // 上传图片
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.shareInfo.image = response.data.url
        this.shareInfo.size = response.data.size
        this.shareInfo.suffix = response.data.subString
      })
    }
  },
  mounted () {
    this.shareInfo.id = this.$route.query.item
    if (!this.shareInfo.id) {
      this.shareInfo.appType = ''
      this.titlename = '添加'
    } else {
      this.titlename = '修改'
      this.getData()
    }
  }
}
</script>
<style lang="stylus">
.addShare
  width calc(100% - 40px)
  height calc(100% - 20px)
  background #fff
  margin 0 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 70px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    overflow-y auto
    .addShareInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../assets/images/03/add_icon.png') no-repeat center left 15px
    .shareContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      // border-bottom 1px solid #CFD5DC
      .sharelist
        margin-top 26px
        overflow hidden
        label
          width 120px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
        .imgItem
          margin-left 135px
          width 350px
          position relative
          .image
            width 172px
            height 130px
            img
              width 100%
              height 100%
          .updateImgBtn
            position absolute
            width 112px
            height 30px
            cursor pointer
            background #00D5B9
            text-align center
            text-indent 2em
            line-height 32px
            right 10px
            top 50px
            border-radius 3px
            background url('../../assets/images/07/upload_icon.png') no-repeat center left 20px #00D5B9
            size12()
            color #FFFFFF
            .updateBtn
              position absolute
              top 0px
              left 0px
              cursor pointer
              opacity 0
              right 0px
              bottom 0px
              overflow hidden
          .remark
            margin-top 20px
            color #5E656F
            background url('../../assets/images/07/tishi_icon_photo.png') no-repeat center left 5px
            text-indent 2em
            height 14px
            line-height 14px
      .shareBtn
        margin-left 116px
        margin-top 74px
        margin-bottom 20px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
